import React from "react";
import "../styles/Impressum.css";

const Datenschutz = () => (
  <div className="impressum-page">
    <h1>Datenschutzerklärung</h1>

    <section className="impressum-section">
      <h2>1. Verantwortlicher</h2>
      <p>
        Tennisgemeinschaft Thedinghausen e. V.<br />
        Am Burgplatz 7<br />
        27321 Thedinghausen<br />
        E-Mail: <a href="mailto:tgt@tennis-thedinghausen.de">tgt@tennis-thedinghausen.de</a>
      </p>
      <p>
        <strong>Datenschutzverantwortlicher:</strong><br />
        Dirk Struck (Kassenwart)<br />
        E-Mail: <a href="mailto:tgt@tennis-thedinghausen.de">tgt@tennis-thedinghausen.de</a>
      </p>
    </section>

    <section className="impressum-section">
      <h2>2. Welche Daten wir speichern</h2>
      <p>
        Im Rahmen der Nutzung dieser Vereinsplattform werden folgende personenbezogene Daten
        verarbeitet:
      </p>
      <p>
        <strong>Bei der Registrierung:</strong> Name, E-Mail-Adresse, Passwort (verschlüsselt
        gespeichert).<br />
        <strong>Turnier- und Spielbetrieb:</strong> Spielpaarungen, Ergebnisse,
        Terminvereinbarungen.<br />
        <strong>Anwesenheitsdaten:</strong> Zugehörigkeit zu Vereinsmannschaften und
        Gruppenphase-Teams.<br />
        <strong>Technische Daten:</strong> Bei jeder Anfrage werden IP-Adresse, Zeitstempel
        und aufgerufene URL im Server-Log kurzzeitig erfasst (max. 7 Tage).
      </p>
    </section>

    <section className="impressum-section">
      <h2>3. Rechtsgrundlagen</h2>
      <p>
        Die Verarbeitung erfolgt auf Basis folgender Rechtsgrundlagen der DSGVO:
      </p>
      <p>
        <strong>Art. 6 Abs. 1 lit. b DSGVO</strong> – Vertragserfüllung: Bereitstellung der
        Vereinsplattform, Turnierverwaltung und Mitgliederkommunikation.<br />
        <strong>Art. 6 Abs. 1 lit. f DSGVO</strong> – Berechtigtes Interesse: Betrieb und
        Sicherheit der technischen Infrastruktur (Server-Logs).
      </p>
    </section>

    <section className="impressum-section">
      <h2>4. Speicherdauer</h2>
      <p>
        Nutzerdaten werden gelöscht, sobald sie für den Vereinsbetrieb nicht mehr erforderlich
        sind oder auf Wunsch des Mitglieds. Server-Logs werden nach spätestens 7 Tagen
        automatisch gelöscht. Turnierergebnisse können als historische Vereinsdaten dauerhaft
        gespeichert bleiben.
      </p>
    </section>

    <section className="impressum-section">
      <h2>5. Cookies und lokaler Speicher</h2>
      <p>
        Diese Plattform verwendet ausschließlich technisch notwendige Cookies und
        Browser-Speicher (localStorage):
      </p>
      <p>
        <strong>Sitzungs-Cookie:</strong> Ein httpOnly-Cookie zur Authentifizierung nach dem
        Login. Ohne diesen Cookie ist eine Anmeldung nicht möglich.<br />
        <strong>localStorage:</strong> Speichert Anmeldestatus und Benutzereinstellungen
        (z. B. gelesene News-Einträge) lokal in Ihrem Browser. Diese Daten verlassen Ihr
        Gerät nicht.<br />
      </p>
      <p>
        Es werden <strong>keine</strong> Tracking-, Analyse- oder Werbe-Cookies eingesetzt.
        Ein Cookie-Banner ist daher gemäß § 25 TTDSG nicht erforderlich.
      </p>
    </section>

    <section className="impressum-section">
      <h2>6. Weitergabe an Dritte</h2>
      <p>
        Personenbezogene Daten werden nicht an Dritte weitergegeben. Die öffentlich
        sichtbaren Turnierergebnisse und Spielerpaarungen sind Teil des regulären
        Vereinsbetriebs und entsprechen dem Zweck der Mitgliedschaft.
      </p>
      <p>
        Externe Verlinkungen (z. B. tennis04-Platzbuchungsplattform, Vereins-Website) fallen
        nicht unter diese Datenschutzerklärung; bitte beachten Sie dort die jeweiligen
        Datenschutzhinweise.
      </p>
    </section>

    <section className="impressum-section">
      <h2>7. Ihre Rechte</h2>
      <p>
        Sie haben gegenüber dem Verein folgende Rechte bezüglich Ihrer personenbezogenen
        Daten:
      </p>
      <p>
        <strong>Auskunft</strong> (Art. 15 DSGVO) · <strong>Berichtigung</strong> (Art. 16) ·{" "}
        <strong>Löschung</strong> (Art. 17) · <strong>Einschränkung</strong> (Art. 18) ·{" "}
        <strong>Widerspruch</strong> (Art. 21)
      </p>
      <p>
        Zur Ausübung Ihrer Rechte wenden Sie sich an:{" "}
        <a href="mailto:tgt@tennis-thedinghausen.de">tgt@tennis-thedinghausen.de</a>
      </p>
    </section>

    <section className="impressum-section">
      <h2>8. Beschwerderecht</h2>
      <p>
        Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
        Zuständig ist die Landesbeauftragte für den Datenschutz Niedersachsen:<br />
        <a
          href="https://www.lfd.niedersachsen.de"
          target="_blank"
          rel="noreferrer"
        >
          www.lfd.niedersachsen.de
        </a>
      </p>
    </section>
  </div>
);

export default Datenschutz;
